module.exports = __webpack_public_path__ + "img/CRC2_Treg.12f9e154.png";